import React from "react";
// import { useState } from "react";
import { useForm } from "react-hook-form";
import InnerHeader from "../../component/shared/innerheader/InnerHeader.js";
import { FormattedMessage, useIntl } from "react-intl";
import ChevronIcon from "svg-icons/chevron-icon.js";
import useSWR from "swr";
import { END_POINTS } from "constants/APIConstant.js";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import fetch from "../../auth/FetchInterceptor.js";
import { useDispatch, useSelector } from "react-redux";
import "./../subscribeForm/subscribeForm.scss";
import ContentLoading from "component/LoadingComponent/ContentLoading.js";
import MainDepartment from "component/shared/main-department/MainDepartment.jsx";
import HtmlView from "component/htmlView/html-view.js";
import { LabelLangString } from "component/LabelLang/label-lang.js";
import AboutDepartment from "component/shared/about-department/AboutDepartment.jsx";
import {
  agencyType,
  usageQualityOptions,
  workWithStatisticsOptions,
} from "constants/Defaults.js";
import { apiResponseMessage } from "redux/actions/ApiMessageResponse.js";
import { MESSAGE_TYPE } from "redux/constants/ApiMessageResponse.js";
import ReactGA from "react-ga4";

function NationalCenter() {
  const intl = useIntl();

  const dir = useSelector(({ theme }) => theme.direction);
  const currentLocale = useSelector(({ theme }) => theme.locale);
  const dispatch = useDispatch();

  React.useEffect(() => {
    const timeOut = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
    return () => {
      clearTimeout(timeOut);
    };
  }, []);

  const governoratesData = useSWR({ url: END_POINTS.GOVERNORATES });

  ReactGA.initialize(END_POINTS.TRACKING_ID);

  React.useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({
      hitType: "pageview",
      page: "/nationalCenter",
      title: "NationalCenter Page",
    });
  }, []);

  // const [data, setData] = useState("");

  const formSchema = Yup.object().shape({
    name: Yup.string()
      // .matches(
      //   /^[a-zA-Z]{2,20}\s[a-zA-Z]{2,20}\s[a-zA-Z]{2,20}\s[a-zA-Z]{2,20}$/g,
      //   "Please enter valid name"
      // )
      .min(11)
      .max(80),
    nationalId: Yup.string().matches(
      /^[0-9]{14}$/,
      "Please enter valid National Id consists of 14 numbers"
    ),
    residence: Yup.string().required(),
    // .matches(/^[a-zA-Z0-9 ]{5,50}$/, "Please enter valid residence")
    // .min(5)
    // .max(50),

    // governorate: Yup.string().required(),
    // .matches(/^[a-zA-Z0-9]{5,50}$/, "Please enter valid governorate")
    // .min(5)
    // .max(50),
    email: Yup.string().matches(
      /^[a-zA-Z0-9.!#$%&'*+=?^_]{3,25}@(?:[a-zA-Z0-9-]{1,63}\.)+[a-zA-Z]{3,25}$/,
      `Please enter valid email:
          Username must be between 3 and 25 characters.
          Username can only contain letters, numbers, and special characters.
          Domain name must be between 1 and 63 characters.
          Domain name extension must be .text between 3 and 25 characters.
        `
    ),
    workPostalNumber: Yup.string()
      .matches(/^[0-9]*$/, "postal code must be digits")
      .max(5, "postal code must be at most 5 characters")
      .min(2, "postal code must be at least 2 characters"),
    phoneNumber: Yup.string()
      .matches(/^[0-9]*$/)
      .max(15)
      .min(7),
    workPhone: Yup.string()
      .matches(/^[0-9]*$/)
      .max(15)
      .min(7),
    workAddress: Yup.string().required(),
    jobTitle: Yup.string().required(),
    // .matches(/^[a-zA-Z0-9 ]{5,50}$/, "Please enter valid job Title")
    // .min(5)
    // .max(50),
    jobRanking: Yup.string().required(),
    workNature: Yup.string().required(),
    // .matches(/^[a-zA-Z ]{5,20}$/, "Please enter Work Nature")
    // .min(5)
    // .max(20),
    currentWorkDuration: Yup.string().required(),
    academicQualification: Yup.string().required(),
    academicSpecialization: Yup.string().required(),
    qualificationSource: Yup.string().required(),
    qualificationYear: Yup.string().required(),
    otherQualifications: Yup.string().required(),
    lastTrainingPrograms: Yup.string().required(),
    trainerName: Yup.string().required(),
    // .matches(/^[a-zA-Z ]{2,20}$/g, "Please enter valid name")
    // .min(11)
    // .max(80),
    trainerJobTitle: Yup.string().required(),
    // .matches(/^[a-zA-Z0-9 ]{5,50}$/, "Please enter valid job Title")
    // .min(5)
    // .max(50),
    trainerPhone: Yup.string()
      .matches(/^[0-9]*$/)
      .max(15)
      .min(7),
    trainerFax: Yup.string().required(),
    trainerEmail: Yup.string().matches(
      /^[a-zA-Z0-9.!#$%&'*+/=?^_]{3,25}(@[a-zA-Z0-9]{3,25}\.[a-zA-Z]{3,25})$/,
      `Please enter valid email:
          Username must be between 3 and 25 characters.
          Username can only contain letters, numbers, and special characters.
          Domain name must be between 3 and 25 characters.
          Domain name extension must be .text between 3 and 25 characters.
        `
    ),
  });

  const formOptions = {
    resolver: yupResolver(formSchema),
    defaultValues: {
      governorate: "1",
      workSource: "1",
      trainingProgramId: "1",
      workWithStatistics: "1",
      computerUsageQuality: "1",
      spssUsageQuality: "1",
    },
  };

  const { control, register, handleSubmit, reset, formState } =
    useForm(formOptions);
  const { errors } = formState;

  const onSubmit = async (data) => {
    try {
      var result = await postNationalCenter(data);
      if (result?.state) {
        dispatch(
          apiResponseMessage({
            showMessage: true,
            message: <FormattedMessage id="sent-successfully" />,
            messageType: MESSAGE_TYPE.SUCCESS,
          })
        );
      } else {
        dispatch(
          apiResponseMessage({
            showMessage: true,
            message: result?.data?.message ? (
              result?.data?.message
            ) : (
              <FormattedMessage id="timeout-error" />
            ),
            messageType: MESSAGE_TYPE.ERROR,
          })
        );
      }
    } catch (error) {
      dispatch(
        apiResponseMessage({
          showMessage: true,
          message: error?.response?.data?.message ? (
            error?.response?.data?.message
          ) : (
            <FormattedMessage id="timeout-error" />
          ),
          messageType: MESSAGE_TYPE.ERROR,
        })
      );
    }
  };

  async function postNationalCenter(data) {
    let postData = {
      name: data.name,
      nationalId: data.nationalId,
      residence: data.residence,
      governorate: data.governorate,
      phoneNumber: data.phoneNumber,
      email: data.email,
      workSource: data.workSource,
      workPostalNumber: data.workPostalNumber,
      workAddress: data.workAddress,
      workPhone: data.workPhone,
      jobTitle: data.jobTitle,
      jobRanking: data.jobRanking,
      workNature: data.workNature,
      workWithStatistics: data.workWithStatistics,
      currentWorkDuration: data.currentWorkDuration,
      academicQualification: data.academicQualification,
      academicSpecialization: data.academicSpecialization,
      qualificationSource: data.qualificationSource,
      qualificationYear: data.qualificationYear,
      otherQualifications: data.otherQualifications,
      lastTrainingPrograms: data.lastTrainingPrograms,
      computerUsageQuality: data.computerUsageQuality,
      spssUsageQuality: data.spssUsageQuality,
      trainerName: data.trainerName,
      trainerJobTitle: data.trainerJobTitle,
      trainerPhone: data.trainerPhone,
      trainerFax: data.trainerFax,
      trainerEmail: data.trainerEmail,
      trainingProgramId: data.trainingProgramId,
      isPublished: true,
      status: 3,
    };
    return await fetch.post(END_POINTS.TRAINING_PROGRAM_ADD, postData);
  }

  const getTrainingProgram = useSWR({
    url: END_POINTS.TRAINING_PROGRAM_LOOKUP,
  });

  const getServices = useSWR({
    url: `${END_POINTS.SERVICES_TOOLS}/${END_POINTS.NATIONAL_CENTER_ID}`,
  });

  const getDepartment = useSWR({
    url: `${END_POINTS.SERVICES_TOOLS_DEPARTMENT}=${END_POINTS.NATIONAL_CENTER_ID}`,
  });

  return (
    <ContentLoading
      isLoading={
        getDepartment.isLoading ||
        getServices.isLoading ||
        getTrainingProgram.isLoading
      }
    >
      <div className="national-center">
        <InnerHeader
          breadcrumb={[
            {
              title: intl.formatMessage({ id: "service-tools" }),
              clickClass: false,
            },
            {
              title: intl.formatMessage({ id: "national-center-services" }),
              clickClass: true,
            },
          ]}
          title={intl.formatMessage({ id: "national-center-title" })}
          route={"../servicestools"}
        />

        <div className="container py-5">
          <div className="row">
            <div className="col-lg-8">
              <div className="m__title">
                <h3>
                  <FormattedMessage id="national-center" />
                </h3>
              </div>

              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="data-form">
                  <h5
                    className="fw-bold mb-4 text-decoration-underline"
                    style={{ color: "var(--main-color)" }}
                  >
                    <FormattedMessage id="personalData" />
                  </h5>

                  <div className="form-label row">
                    <div className="col-lg-4">
                      <label>
                        <FormattedMessage id="trainingProgram" />:
                      </label>
                    </div>

                    <div className="col-lg-8">
                      <div className="dropdown">
                        <select
                          className={`${dir === "rtl" ? "r-dir" : "l-dir"}`}
                          required
                          {...register("trainingProgramId")}
                        >
                          {getTrainingProgram?.data?.data.map(
                            ({ id, name, translations }, i) => (
                              <option
                                key={i}
                                value={id}
                                title={LabelLangString({
                                  id: "name",
                                  currentLocale: currentLocale,
                                  defaultValue: name,
                                  translations: translations,
                                })}
                              >
                                {LabelLangString({
                                  id: "name",
                                  currentLocale: currentLocale,
                                  defaultValue: name,
                                  translations: translations,
                                })}
                              </option>
                            )
                          )}
                        </select>
                        <span>*</span>
                      </div>
                    </div>
                  </div>
                  <div className="form-label row">
                    <div className="col-lg-4">
                      <label>
                        <FormattedMessage id="quadName" />:
                      </label>
                    </div>

                    <div className="col-lg-8">
                      <div className="form-label-container">
                        <input
                          type="text"
                          required
                          {...register("name")}
                          className={`form-control ${
                            errors.name ? "is-invalid" : ""
                          }`}
                        />
                        <span>*</span>
                      </div>
                      {errors?.name?.message && (
                        <span className="alert alert-danger py-1">
                          {errors?.name?.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-label row">
                    <div className="col-lg-4">
                      <label>
                        <FormattedMessage id="nationalId" />:
                      </label>
                    </div>

                    <div className="col-lg-8">
                      <div className="form-label-container">
                        <input
                          type="number"
                          required
                          {...register("nationalId")}
                          className={`form-control ${
                            errors.nationalId ? "is-invalid" : ""
                          }`}
                        />
                        <span>*</span>
                      </div>
                      {errors?.nationalId?.message && (
                        <span className="alert alert-danger py-1">
                          {errors?.nationalId?.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-label row">
                    <div className="col-lg-4">
                      <label>
                        <FormattedMessage id="residence" />:
                      </label>
                    </div>

                    <div className="col-lg-8">
                      <div className="form-label-container">
                        <input
                          type="text"
                          required
                          {...register("residence")}
                          className={`form-control ${
                            errors.residence ? "is-invalid" : ""
                          }`}
                        />
                        <span>*</span>
                      </div>
                      {errors?.residence?.message && (
                        <span className="alert alert-danger py-1">
                          {errors?.residence?.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-label row">
                    <div className="col-lg-4">
                      <label>
                        <FormattedMessage id="governorate" />:
                      </label>
                    </div>

                    <div className="col-lg-8">
                      <div className="form-label-container">
                        {/* <input
                          type="text"
                          required
                          {...register("governorate")}
                          className={`form-control ${
                            errors.governorate ? "is-invalid" : ""
                          }`}
                        /> */}
                        <select
                          className={`${dir === "rtl" ? "r-dir" : "l-dir"}`}
                          required
                          {...register("governorate")}
                        >
                          {governoratesData?.data?.data.map(
                            ({ id, name, governorateTranslations }, i) => (
                              <option
                                key={i}
                                value={id}
                                title={LabelLangString({
                                  id: "name",
                                  currentLocale: currentLocale,
                                  defaultValue: name,
                                  translations: governorateTranslations,
                                })}
                              >
                                {LabelLangString({
                                  id: "name",
                                  currentLocale: currentLocale,
                                  defaultValue: name,
                                  translations: governorateTranslations,
                                })}
                              </option>
                            )
                          )}
                        </select>
                        <span>*</span>
                      </div>
                      {errors?.governorate?.message && (
                        <span className="alert alert-danger py-1">
                          {errors?.governorate?.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-label row">
                    <div className="col-lg-4">
                      <label>
                        <FormattedMessage id="phoneNumber" />:
                      </label>
                    </div>

                    <div className="col-lg-8">
                      <div className="form-label-container">
                        <input
                          type="tel"
                          required
                          {...register("phoneNumber")}
                          className={`form-control ${
                            errors.phoneNumber ? "is-invalid" : ""
                          }`}
                        />
                        <span>*</span>
                      </div>
                      {errors?.phoneNumber?.message && (
                        <span className="alert alert-danger py-1">
                          {errors?.phoneNumber?.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-label row">
                    <div className="col-lg-4">
                      <label>
                        <FormattedMessage id="email" />:
                      </label>
                    </div>

                    <div className="col-lg-8">
                      <div className="form-label-container">
                        <input
                          type="email"
                          required
                          {...register("email")}
                          className={`form-control ${
                            errors.email ? "is-invalid" : ""
                          }`}
                        />
                        <span>*</span>
                      </div>
                      {errors?.email?.message && (
                        <span className="alert alert-danger py-1">
                          {errors?.email?.message}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="data-form">
                  <h5
                    className="fw-bold mb-4 text-decoration-underline"
                    style={{ color: "var(--main-color)" }}
                  >
                    <FormattedMessage id="employer-data" />
                  </h5>

                  <div className="form-label row">
                    <div className="col-lg-4">
                      <label>
                        <FormattedMessage id="employer" />:
                      </label>
                    </div>

                    <div className="col-lg-8">
                      <div className="dropdown">
                        <select
                          className={`${dir === "rtl" ? "r-dir" : "l-dir"}`}
                          required
                          {...register("workSource")}
                        >
                          {agencyType.map(({ id, name, Translation }, i) => (
                            <option
                              key={i}
                              value={id}
                              title={LabelLangString({
                                id: "name",
                                currentLocale: currentLocale,
                                defaultValue: name,
                                translations: Translation,
                              })}
                            >
                              {LabelLangString({
                                id: "name",
                                currentLocale: currentLocale,
                                defaultValue: name,
                                translations: Translation,
                              })}
                            </option>
                          ))}
                        </select>
                        <span>*</span>
                      </div>
                    </div>
                  </div>
                  <div className="form-label row">
                    <div className="col-lg-4">
                      <label>
                        <FormattedMessage id="postalCode" />:
                      </label>
                    </div>

                    <div className="col-lg-8">
                      <div className="form-label-container">
                        <input
                          type="text"
                          required
                          {...register("workPostalNumber")}
                          className={`form-control ${
                            errors.workPostalNumber ? "is-invalid" : ""
                          }`}
                        />
                        <span>*</span>
                      </div>
                      {errors?.workPostalNumber?.message && (
                        <span className="alert alert-danger py-1">
                          {errors?.workPostalNumber?.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-label row">
                    <div className="col-lg-4">
                      <label>
                        <FormattedMessage id="empolyerAddress" />:
                      </label>
                    </div>

                    <div className="col-lg-8">
                      <div className="form-label-container">
                        <input
                          type="text"
                          required
                          {...register("workAddress")}
                          className={`form-control ${
                            errors.workAddress ? "is-invalid" : ""
                          }`}
                        />
                        <span>*</span>
                      </div>
                      {errors?.workAddress?.message && (
                        <span className="alert alert-danger py-1">
                          {errors?.workAddress?.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-label row">
                    <div className="col-lg-4">
                      <label>
                        <FormattedMessage id="empolyerPhone" />:
                      </label>
                    </div>

                    <div className="col-lg-8">
                      <div className="form-label-container">
                        <input
                          type="tel"
                          required
                          {...register("workPhone")}
                          className={`form-control ${
                            errors.workPhone ? "is-invalid" : ""
                          }`}
                        />
                        <span>*</span>
                      </div>
                      {errors?.workPhone?.message && (
                        <span className="alert alert-danger py-1">
                          {errors?.workPhone?.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-label row">
                    <div className="col-lg-4">
                      <label>
                        <FormattedMessage id="jobTitle" />:
                      </label>
                    </div>

                    <div className="col-lg-8">
                      <div className="form-label-container">
                        <input
                          type="text"
                          required
                          {...register("jobTitle")}
                          className={`form-control ${
                            errors.jobTitle ? "is-invalid" : ""
                          }`}
                        />
                        <span>*</span>
                      </div>
                      {errors?.jobTitle?.message && (
                        <span className="alert alert-danger py-1">
                          {errors?.jobTitle?.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-label row">
                    <div className="col-lg-4">
                      <label>
                        <FormattedMessage id="jobClass" />:
                      </label>
                    </div>

                    <div className="col-lg-8">
                      <div className="form-label-container">
                        <input
                          type="text"
                          required
                          {...register("jobRanking")}
                          className={`form-control ${
                            errors.jobRanking ? "is-invalid" : ""
                          }`}
                        />
                        <span>*</span>
                      </div>
                      {errors?.jobRanking?.message && (
                        <span className="alert alert-danger py-1">
                          {errors?.jobRanking?.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-label row">
                    <div className="col-lg-4">
                      <label>
                        <FormattedMessage id="workNature" />:
                      </label>
                    </div>

                    <div className="col-lg-8">
                      <div className="form-label-container">
                        <input
                          type="text"
                          required
                          {...register("workNature")}
                          className={`form-control ${
                            errors.workNature ? "is-invalid" : ""
                          }`}
                        />
                        <span>*</span>
                      </div>
                      {errors?.workNature?.message && (
                        <span className="alert alert-danger py-1">
                          {errors?.workNature?.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-label row">
                    <div className="col-lg-4">
                      <label>
                        <FormattedMessage id="connectionValue" />:
                      </label>
                    </div>

                    <div className="col-lg-8">
                      <div className="dropdown">
                        <select
                          className={`${dir === "rtl" ? "r-dir" : "l-dir"}`}
                          required
                          {...register("workWithStatistics")}
                        >
                          {workWithStatisticsOptions.map(
                            ({ id, name, Translation }, i) => (
                              <option
                                key={i}
                                value={id}
                                title={LabelLangString({
                                  id: "name",
                                  currentLocale: currentLocale,
                                  defaultValue: name,
                                  translations: Translation,
                                })}
                              >
                                {LabelLangString({
                                  id: "name",
                                  currentLocale: currentLocale,
                                  defaultValue: name,
                                  translations: Translation,
                                })}
                              </option>
                            )
                          )}
                        </select>
                        <span>*</span>
                      </div>
                    </div>
                  </div>
                  <div className="form-label row">
                    <div className="col-lg-4">
                      <label>
                        <FormattedMessage id="durationWork" />:
                      </label>
                    </div>

                    <div className="col-lg-8">
                      <div className="form-label-container">
                        <input
                          type="text"
                          required
                          {...register("currentWorkDuration")}
                          className={`form-control ${
                            errors.currentWorkDuration ? "is-invalid" : ""
                          }`}
                        />
                        <span>*</span>
                      </div>
                      {errors?.currentWorkDuration?.message && (
                        <span className="alert alert-danger py-1">
                          {errors?.currentWorkDuration?.message}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="data-form">
                  <h5
                    className="fw-bold mb-4 text-decoration-underline"
                    style={{ color: "var(--main-color)" }}
                  >
                    <FormattedMessage id="the-educational-qualification" />
                  </h5>

                  <div className="form-label row">
                    <div className="col-lg-4">
                      <label>
                        <FormattedMessage id="main-educational-qualification" />
                        :
                      </label>
                    </div>

                    <div className="col-lg-8">
                      <div className="form-label-container">
                        <input
                          type="text"
                          required
                          {...register("academicQualification")}
                          className={`form-control ${
                            errors.academicQualification ? "is-invalid" : ""
                          }`}
                        />
                        <span>*</span>
                      </div>
                      {errors?.academicQualification?.message && (
                        <span className="alert alert-danger py-1">
                          {errors?.academicQualification?.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-label row">
                    <div className="col-lg-4">
                      <label>
                        <FormattedMessage id="specialty" />:
                      </label>
                    </div>

                    <div className="col-lg-8">
                      <div className="form-label-container">
                        <input
                          type="text"
                          required
                          {...register("academicSpecialization")}
                          className={`form-control ${
                            errors.academicSpecialization ? "is-invalid" : ""
                          }`}
                        />
                        <span>*</span>
                      </div>
                      {errors?.academicSpecialization?.message && (
                        <span className="alert alert-danger py-1">
                          {errors?.academicSpecialization?.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-label row">
                    <div className="col-lg-4">
                      <label>
                        <FormattedMessage id="where-to-get-it" />:
                      </label>
                    </div>

                    <div className="col-lg-8">
                      <div className="form-label-container">
                        <input
                          type="text"
                          required
                          {...register("qualificationSource")}
                          className={`form-control ${
                            errors.qualificationSource ? "is-invalid" : ""
                          }`}
                        />
                        <span>*</span>
                      </div>
                      {errors?.qualificationSource?.message && (
                        <span className="alert alert-danger py-1">
                          {errors?.qualificationSource?.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-label row">
                    <div className="col-lg-4">
                      <label>
                        <FormattedMessage id="year-get-it" />:
                      </label>
                    </div>

                    <div className="col-lg-8">
                      <div className="form-label-container">
                        <input
                          type="number"
                          required
                          {...register("qualificationYear")}
                          className={`form-control ${
                            errors.qualificationYear ? "is-invalid" : ""
                          }`}
                        />
                        <span>*</span>
                      </div>
                      {errors?.qualificationYear?.message && (
                        <span className="alert alert-danger py-1">
                          {errors?.qualificationYear?.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-label row">
                    <div className="col-lg-4">
                      <label>
                        <FormattedMessage id="other-qualifications" />:
                      </label>
                    </div>

                    <div className="col-lg-8">
                      <div className="form-label-container">
                        <input
                          type="text"
                          required
                          {...register("otherQualifications")}
                          className={`form-control ${
                            errors.otherQualifications ? "is-invalid" : ""
                          }`}
                        />
                        <span>*</span>
                      </div>
                      {errors?.otherQualifications?.message && (
                        <span className="alert alert-danger py-1">
                          {errors?.otherQualifications?.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-label row">
                    <div className="col-lg-4">
                      <label>
                        <FormattedMessage id="lastTrainingPrograms" />:
                      </label>
                    </div>

                    <div className="col-lg-8">
                      <div className="form-label-container">
                        <input
                          type="text"
                          required
                          {...register("lastTrainingPrograms")}
                          className={`form-control ${
                            errors.lastTrainingPrograms ? "is-invalid" : ""
                          }`}
                        />
                        <span>*</span>
                      </div>
                      {errors?.lastTrainingPrograms?.message && (
                        <span className="alert alert-danger py-1">
                          {errors?.lastTrainingPrograms?.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-label row">
                    <div className="col-lg-4">
                      <label>
                        <FormattedMessage id="computerUsageQuality" />:
                      </label>
                    </div>

                    <div className="col-lg-8">
                      <div className="dropdown">
                        <select
                          className={`${dir === "rtl" ? "r-dir" : "l-dir"}`}
                          required
                          {...register("computerUsageQuality")}
                        >
                          {usageQualityOptions.map(
                            ({ id, name, Translation }, i) => (
                              <option
                                key={i}
                                value={id}
                                title={LabelLangString({
                                  id: "name",
                                  currentLocale: currentLocale,
                                  defaultValue: name,
                                  translations: Translation,
                                })}
                              >
                                {LabelLangString({
                                  id: "name",
                                  currentLocale: currentLocale,
                                  defaultValue: name,
                                  translations: Translation,
                                })}
                              </option>
                            )
                          )}
                        </select>
                        <span>*</span>
                      </div>
                    </div>
                  </div>
                  <div className="form-label row">
                    <div className="col-lg-4">
                      <label>
                        <FormattedMessage id="spssUsageQuality" />:
                      </label>
                    </div>

                    <div className="col-lg-8">
                      <div className="dropdown">
                        <select
                          className={`${dir === "rtl" ? "r-dir" : "l-dir"}`}
                          required
                          {...register("spssUsageQuality")}
                        >
                          {usageQualityOptions.map(
                            ({ id, name, Translation }, i) => (
                              <option
                                key={i}
                                value={id}
                                title={LabelLangString({
                                  id: "name",
                                  currentLocale: currentLocale,
                                  defaultValue: name,
                                  translations: Translation,
                                })}
                              >
                                {LabelLangString({
                                  id: "name",
                                  currentLocale: currentLocale,
                                  defaultValue: name,
                                  translations: Translation,
                                })}
                              </option>
                            )
                          )}
                        </select>
                        <span>*</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="data-form">
                  <h5
                    className="fw-bold mb-4 text-decoration-underline"
                    style={{ color: "var(--main-color)" }}
                  >
                    <FormattedMessage id="trainnerData" />
                  </h5>

                  <div className="form-label row">
                    <div className="col-lg-4">
                      <label>
                        <FormattedMessage id="name" />:
                      </label>
                    </div>

                    <div className="col-lg-8">
                      <div className="form-label-container">
                        <input
                          type="text"
                          required
                          {...register("trainerName")}
                          className={`form-control ${
                            errors.trainerName ? "is-invalid" : ""
                          }`}
                        />
                        <span>*</span>
                      </div>
                      {errors?.trainerName?.message && (
                        <span className="alert alert-danger py-1">
                          {errors?.trainerName?.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-label row">
                    <div className="col-lg-4">
                      <label>
                        <FormattedMessage id="jobTitle" />:
                      </label>
                    </div>

                    <div className="col-lg-8">
                      <div className="form-label-container">
                        <input
                          type="text"
                          required
                          {...register("trainerJobTitle")}
                          className={`form-control ${
                            errors.trainerJobTitle ? "is-invalid" : ""
                          }`}
                        />
                        <span>*</span>
                      </div>
                      {errors?.trainerJobTitle?.message && (
                        <span className="alert alert-danger py-1">
                          {errors?.trainerJobTitle?.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-label row">
                    <div className="col-lg-4">
                      <label>
                        <FormattedMessage id="phoneNumber" />:
                      </label>
                    </div>

                    <div className="col-lg-8">
                      <div className="form-label-container">
                        <input
                          type="tel"
                          required
                          {...register("trainerPhone")}
                          className={`form-control ${
                            errors.trainerPhone ? "is-invalid" : ""
                          }`}
                        />
                        <span>*</span>
                      </div>
                      {errors?.trainerPhone?.message && (
                        <span className="alert alert-danger py-1">
                          {errors?.trainerPhone?.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-label row">
                    <div className="col-lg-4">
                      <label>
                        <FormattedMessage id="fax" />:
                      </label>
                    </div>

                    <div className="col-lg-8">
                      <div className="form-label-container">
                        <input
                          type="text"
                          required
                          {...register("trainerFax")}
                          className={`form-control ${
                            errors.trainerFax ? "is-invalid" : ""
                          }`}
                        />
                        <span>*</span>
                      </div>
                      {errors?.trainerFax?.message && (
                        <span className="alert alert-danger py-1">
                          {errors?.trainerFax?.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-label row">
                    <div className="col-lg-4">
                      <label>
                        <FormattedMessage id="email" />:
                      </label>
                    </div>

                    <div className="col-lg-8">
                      <div className="form-label-container">
                        <input
                          type="email"
                          required
                          {...register("trainerEmail")}
                          className={`form-control ${
                            errors.trainerEmail ? "is-invalid" : ""
                          }`}
                        />
                        <span>*</span>
                      </div>
                      {errors?.trainerEmail?.message && (
                        <span className="alert alert-danger py-1">
                          {errors?.trainerEmail?.message}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="row-r mt-4">
                  <button className="main-btn" type="submit">
                    <span>
                      <FormattedMessage id="send" />
                    </span>
                    <ChevronIcon width={12} height={12} color="#FFFFFF" />
                  </button>
                </div>
              </form>
            </div>

            <div className="col-lg-4">
              <AboutDepartment
                id={"about"}
                txt={getServices?.data?.data?.about}
                translations={
                  getServices?.data?.data?.serviceAndToolTranslation
                }
              />
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-12 col-lg-8">
              <div className="service-content">
                {getServices?.data?.data?.content !== null &&
                getServices?.data?.data?.content !== undefined ? (
                  <HtmlView
                    html={LabelLangString({
                      id: "content",
                      currentLocale: currentLocale,
                      defaultValue: getServices?.data?.data?.content,
                      translations:
                        getServices?.data?.data?.serviceAndToolTranslation,
                    })}
                  />
                ) : (
                  <FormattedMessage id="data-not-found" />
                )}
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <MainDepartment getDepartment={getDepartment} />
            </div>
          </div>
        </div>
      </div>
    </ContentLoading>
  );
}

export default NationalCenter;
